// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3ZpgJ","filesListContainer":"PosDisputesFiles_filesListContainer__lXEF2","filesButton":"PosDisputesFiles_filesButton__3dxC6"};